"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instagram = void 0;
exports.instagram = function (axios) { return ({
    getInstagramLoginUrl: function () {
        return axios.get('/instagram/login-url');
    },
    getInstagramConfiguration: function (request) {
        return axios.get('/instagram/configurations', request);
    },
    getInstagramToken: function (request) {
        return axios.get('/instagram/token', request);
    },
    deleteInstagramToken: function (request) {
        return axios.delete('/instagram/token', request);
    },
    getInstagramPreview: function (request) {
        return axios.get('/instagram/preview', request);
    }
}); };
